import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const adhocQueryApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    selectQuery: builder.mutation({
      query: (data: any) => ({
        url: `/adhocqueryclient/selectquery`,
        method: "POST",
        body: data,
      }),
    }),
    exportQuery: builder.mutation({
      query: (data: any) => ({
        url: `/adhocqueryclient/export`,
        method: "POST",
        body: data,
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    insertQuery: builder.mutation({
      query: (data: any) => ({
        url: `/adhocqueryclient/insertquery`,
        method: "POST",
        body: data,
      }),
    }),
    updateQuery: builder.mutation({
      query: (data: any) => ({
        url: `/adhocqueryclient/updatequery`,
        method: "POST",
        body: data,
      }),
    }),
    deleteQuery: builder.mutation({
      query: (data: any) => ({
        url: `/adhocqueryclient/deletequery`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useSelectQueryMutation,
  useExportQueryMutation,
  useInsertQueryMutation,
  useUpdateQueryMutation,
  useDeleteQueryMutation,
} = adhocQueryApiSlice;
